import React, { useState } from "react";
import { Modal, Row, Col } from "antd";
import HButton from "../../../components/custom/input/button/Button";

const ConfirmAlertModal = React.memo((props) => {
    const {
        onCancel,
        open,
        onConfirm,
        centered,
        alertIcon,
        titleContent,
        modalContent,
        buttonConfirm,
        buttonClassName = "",
        buttonType = "primary",
        dataCyForConfirmBtn,
        dataCyForCancelBtn,
        disabled = false,
    } = props;
    const [confirmLoading, setConfirmLoading] = useState(false);
    const handleModalConfirm = async () => {
        if (onConfirm) {
            setConfirmLoading(true);
            await onConfirm();
            setConfirmLoading(false);
        }
    };

    return (
        <>
            <Modal
                open={open}
                onCancel={onCancel}
                centered={centered}
                width={400}
                closable
                destroyOnClose
                footer={
                    <div className="d-flex align-items-center justify-content-between mt-3 m-2">
                        <HButton
                            variant="cancel"
                            buttonClassName={`w-100 me-2 h-45 hs-fw-500`}
                            onClick={onCancel}
                            data-cy={dataCyForCancelBtn}
                        >
                            <span className="hs-fs-14 hs-fw-500 hs-color-text-grey-3">Cancel</span>
                        </HButton>
                        <HButton
                            buttonClassName={`w-100 ms-2 h-45 hs-fw-600 ${buttonClassName}`}
                            type={buttonType}
                            onClick={handleModalConfirm}
                            loading={confirmLoading}
                            disabled={disabled}
                            data-cy={dataCyForConfirmBtn}
                        >
                            {buttonConfirm}
                        </HButton>
                    </div>
                }
            >
                <Row>
                    <Col span={22}>
                        <div className="d-flex align-items-center p-1  ps-0">{alertIcon}</div>
                    </Col>
                </Row>
                <div style={{ fontSize: "16px", fontWeight: 600 }} className="mb-1 mt-2">
                    {titleContent}
                </div>
                <div className="pb-3">{modalContent}</div>
            </Modal>
        </>
    );
});

export default ConfirmAlertModal;
